import { identityHeaders } from './identity.js';

export async function fetchConfig({ apiUrl, apiKey, locale, userContext }) {
    const headers = {
        Accept: 'application/json',
        Authorization: 'Bearer ' + apiKey,
        ...identityHeaders(userContext),
    };

    if (locale) {
        headers['X-Assilya-Locale'] = locale;
    }

    const response = await fetch(apiUrl + '/chatbot/config', { method: 'GET', headers });

    if (!response.ok) {
        throw new Error('chatbot config request failed: ' + response.status);
    }

    return response.json();
}
